import { boronClient } from "../../api";
import { useBoronMutation } from "../../hooks/http/useBoronMutation";

/**
 * 招待承認のためのカスタムフック
 */
export const useAcceptInvitation = () => {
  return useBoronMutation(async ({ invitationId }: { invitationId: string }) =>
    boronClient.PATCH("/api/v1/invitations/{invitation_hashid}", {
      params: {
        path: {
          invitation_hashid: invitationId,
        },
      },
    }),
  );
};

/**
 * 招待拒否のためのカスタムフック
 */
export const useDenyInvitation = () => {
  return useBoronMutation(async ({ invitationId }: { invitationId: string }) =>
    boronClient.DELETE("/api/v1/invitations/{invitation_hashid}", {
      params: {
        path: {
          invitation_hashid: invitationId,
        },
      },
    }),
  );
};
